<template>
  <n-dialog
    v-model="dialog" 
    scrollable
    :width="600"
  >
    <template
      v-if="isShowButton"
      #buttonInside
    >
      <v-btn
        outlined 
        depressed
        :color="color"
        :small="!xLarge"
        :large="xLarge" 
        @click="open"
      >
        <v-img
          v-if="color==='white'"
          src="@/assets/lottery/emojione-monotone_input-numbers.svg"
          alt=""
          width="20"
        /> <h4>{{ $t('group-number-pull-pole') }}</h4>
      </v-btn>
    </template>
    <v-card
      color="var(--bg-main-color)"
      dark
    >
      <v-card-title>
        {{ $t('group-number-pull-pole') }}<v-spacer />
        <v-icon @click="dialog = false">
          mdi-close
        </v-icon>
      </v-card-title>
      <v-card>
        <v-tabs
          v-model="currentItem"
          fixed-tabs
          slider-color="white"
          background-color="var(--bg-secondary-color)"
          dark
        >
          <v-tab
            v-for="item in items"
            :key="item"
          >
            {{ $t(item) }}
          </v-tab>
        </v-tabs>     
        <v-tabs-items v-model="currentItem">
          <v-tab-item>
            <v-card
              v-if="templateNumber.data.length!==0"
              flat
            >   
              <v-data-table
                :headers="headers"
                :items="templateNumber.data"
                :items-per-page="templateNumber.meta.total_item_current_page"
                hide-default-footer
                hide-default-header
              >
                <template #item.action="{ item }"> 
                  <v-btn  
                    fab
                    depressed
                    small
                    dark
                    color="var(--bg-secondary-color)"
                    @click="onButtonClickAddTemplateNumber(item)" 
                  >
                    <v-icon>
                      mdi-plus
                    </v-icon>
                  </v-btn> 
                </template>
              </v-data-table> 
              <div
                v-for="(item,i) in templateNumber.data"
                :key="i"
                class="px-2 py-1 hiddenmobile"
              >
                <pullpole-card 
                  :main-header="item.name" 
                  :sub-header="dateFormat(item.updated_at)" 
                  @add="onButtonClickAddTemplateNumber(item)" 
                />
              </div>
            </v-card>
            <v-card-actions>
              <n-pagination
                v-if="templateNumber.data.length !== 0"
                :meta="templateNumber.meta"
                :page="templateNumber.meta.current_page"
                @nextpage="nextpage"
              />
            </v-card-actions> 
            <loading-status
              :size="30"
              :had-data="hadTemplate"
            /> 
          </v-tab-item>
          <v-tab-item>
            <v-card
              v-if="historyNumber.data.length!==0"
              flat
            > 
              <v-data-table
                :headers="headers2"
                :items="historyNumber.data" 
                :items-per-page="historyNumber.meta.total_item_current_page"
                hide-default-footer
                hide-default-header
              >
                <template v-slot:item.action="{item}">
                  <v-btn  
                    fab
                    depressed 
                    small
                    dark
                    color="var(--bg-secondary-color)"
                    @click="onButtonClickAddHistory(item)" 
                  >
                    <v-icon>
                      mdi-plus
                    </v-icon>
                  </v-btn>
                </template>
              </v-data-table>

              <div
                v-for="(item,i) in historyNumber.data"
                :key="i"
                class="px-2 py-1 hiddenmobile"
              >
                <pullpole-card 
                  :main-header="item.room.name " 
                  :sub-header="dateFormat(item.created_at)" 
                  @add="onButtonClickAddHistory(item)" 
                />
              </div> 
            </v-card> 
            <v-card-actions>
              <n-pagination
                v-if="historyNumber.data.length !== 0"
                :meta="historyNumber.meta"
                :page="historyNumber.meta.current_page"
                @nextpage="nextpageHistroy"
              />
            </v-card-actions>
            <loading-status
              :size="30"
              :had-data="hadHistory"
            /> 
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </v-card>
  </n-dialog>
</template>
<script> 
import { dateFormat } from '@/plugins/time' 
import { st as apiSt, numberTemplate as apiNumberTemplate } from '@/apis'   

export default {
  props : {
    color : {
      type : String,
      default : ()=> 'white'
    },
    xLarge : {
      type : Boolean,
      default : false
    },
    isShowButton: {
      type : Boolean,
      default : false
    }
  }, 
  data () {
    return {
      dialog: false,
      tab: null,
      currentItem: 'tab-Web',  
      items: ['tab.select-group-number','tab.pull-pole'],
      headers: [
        {
          text: 'table.template-number-name',
          align: 'start',
          sortable: false,
          value: 'name',
        },
        { text: 'table.amount', value: 'total_number' },
        { text: 'table.created-at', value: 'updated_at' },
        { text: '', value: 'action' },
        
      ],
      headers2: [
        {
          text: 'table.list',
          align: 'start',
          sortable: false,
          value: 'game_type.name',
        },
        { text: 'table.date-time', value: 'created_at' },
        { text: '', value: 'action' },
        
      ],  
      historyNumber : {
        data : [],
        meta : {
          current_page : 1
        }
      },
      hadTemplate : false,
      hadHistory : false,
      templateNumber : {
        data : [],
        meta : {
          current_page : 1
        }
      }
    } 
  },  
  methods:{ 
    dateFormat,
    nextpage (value) {
      this.templateNumber.meta.current_page = value
      this.getTemplate ()
    },

    nextpageHistroy (value) {
      this.historyNumber.meta.current_page = value
      this.getHistory ()
    },

    async getTemplate (params = {}) {
      params = {
        page : this.templateNumber.meta.current_page
      } 

      const [err, data,,meta] = await apiNumberTemplate.get(params)
      
      this.hadTemplate = true 
      if(err) {
        this.$alert('',err,'warning') 
        return
      }
       
      this.templateNumber.data = data
      this.templateNumber.meta = meta
      this.$forceUpdate()  
    },

    async onButtonClickAddTemplateNumber (item) {  
      this.$ga.event('Button', 'AddDataFromTemplate', 'GamePage','')
      const [err, data, message] =  await apiNumberTemplate.getById(item.uuid)
      
      if(err){
        this.$alert('',err,'warning')
        return
      }  
      this.dialog = false
      this.$emit('addItemFromDialog',data.numbers) 
      this.$alert('',message,'warning')
    },

    async getHistory (params = {}) {
      params = {
        page : this.historyNumber.meta.current_page,
        is_only_internal : 1
      }
      const [err, data,,meta] =  await apiSt.getAllList(params)

      this.hadHistory = true

      if(err){
        this.$alert('',err,'warning')
        return
      } 
       
      this.historyNumber.data = data
      this.historyNumber.meta = meta  
      this.$forceUpdate()   
    },

    async onButtonClickAddHistory (item) {  
      this.$ga.event('Button', 'AddDataFromHistory', 'GamePage','')
      const [err, data] = await apiSt.getListById(item.list_uuid)
      
       if(err){
        this.$alert('',err,'warning')
        return
      } 
      
      this.dialog = false
      this.$emit('addItemFromDialog',data.lists) 
    }, 

    async open () { 
      this.dialog = true
      await this.getTemplate () 
      await this.getHistory ()
      this.$ga.event('Button', 'TemplateNumber&PullRecord', 'GamePage', '') 
    }, 
  }
}
</script> 
<style scoped> 
@media only screen and (max-width: 960px) { 
  .v-data-table {
    display: none !important;
  } 
}   
</style>